import { useParams } from 'react-router-dom';
import Poll from '../../modules/poll/PollPage';
import PollSkeleton from '../../modules/poll/PollPage/skeleton';
import usePollPage from './vm';
import { PollParams } from '../../routes/router';

const PollContent = () => {
  const { isFetchingPollDetails } = usePollPage();

  if (isFetchingPollDetails) {
    return <PollSkeleton />;
  }

  return <Poll />;
};

const PollPage = () => {
  const { pollId } = useParams<PollParams>();
  return <PollContent key={pollId} />;
};

export default PollPage;
